import $ from 'jquery';

export default function carouselModule() {
  const modalElement = $('.swiper-container');
  if (modalElement.length) {
    return import(/* webpackChunkName: "carousel" */ '../carousel')
      .then(({ default: carousel }) => carousel)
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
